import { composeWithDevTools } from '@redux-devtools/extension';
import { checkoutReducer } from 'pages/Checkout/store/reducer/checkout.reducer';
import { createAccountReducer } from 'pages/Create-account/store/reducer/create-account.reducer';
import { editPlanReducer } from 'pages/Edit-plan/Edit-plan-information/store/reducer/edit-plan.reducer';
import { authReducer } from 'pages/sing-in/store/reducer/auth.reducer';
import { combineReducers, createStore } from 'redux';
import { hydrationMetaReducer, saveState } from './hydration/hydration.reducer';
import { appReducer } from './reducer/app.reducer';
import { branchReducer } from './reducer/branch.reducer';

const reducers = combineReducers({
  authReducer,
  branchReducer,
  createAccountReducer,
  appReducer,
  checkoutReducer,
  editPlanReducer,
});

const persistedState = hydrationMetaReducer();
const store = createStore(reducers, persistedState, composeWithDevTools());
store.subscribe(() => {
  saveState({
    authReducer: store.getState().authReducer,
    branchReducer: store.getState().branchReducer,
    createAccountReducer: store.getState().createAccountReducer,
    checkoutReducer: store.getState().checkoutReducer,
    editPlanReducer: store.getState().editPlanReducer,
  });
});

export { store };
